"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationDialogBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const CloseButtonDialogBody_1 = require("./CloseButtonDialogBody");
const Dialog_1 = require("./Dialog");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Button_1 = require("../Button");
const Flex_1 = require("../Flex");
const Paragraph_1 = require("../Paragraph");
const Title = (0, styled_1.default)(Dialog_1.Dialog.Title)({
    color: constants_1.Color.BLUE,
    marginRight: constants_1.theme.spacing[3],
    marginBottom: 0,
    fontSize: constants_1.theme.font.size[6],
    fontWeight: constants_1.theme.font.weight.bold,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
});
const ConfirmationDialogBody = (props) => {
    const t = (0, translate_1.useTranslations)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleConfirmClick = async () => {
        setIsLoading(true);
        try {
            await props.onConfirmClick();
            if (props.autoClose)
                props.onClose();
        }
        finally {
            setIsLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)(CloseButtonDialogBody_1.CloseButtonDialogBody, { styles: { maxWidth: 500 }, children: (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 3, children: [(0, jsx_runtime_1.jsx)(Title, { children: props.heading }), props.description && (0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { m: 0, children: props.description }), props.children, (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 4, children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { design: props.buttonDesign ?? 'danger', loading: isLoading, onClick: handleConfirmClick, disabled: props.disableButton, children: props.buttonText ?? t.ui.confirm() }), (0, jsx_runtime_1.jsx)(Button_1.Button, { design: "primary", onClick: props.onClose, text: true, children: t.ui.cancel() })] })] }) }));
};
exports.ConfirmationDialogBody = ConfirmationDialogBody;
